function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* @indexer:no-export */
import React from 'react';
import styles from './ReadOnlyIndicator.module.scss';
import Tooltip from '../../Tips/Tooltip/Tooltip';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import I18n from '../../I18n/I18n/I18n';
import en from './locales/ReadOnly.en.json';
var ReadOnlyIndicator = /*#__PURE__*/function (_React$Component) {
  _inherits(ReadOnlyIndicator, _React$Component);
  function ReadOnlyIndicator(props) {
    var _this;
    _classCallCheck(this, ReadOnlyIndicator);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReadOnlyIndicator).call(this, props));
    _this.messages = normalizeLocaleData(en, '@dm/components.readonly');
    return _this;
  }
  _createClass(ReadOnlyIndicator, [{
    key: "getRenderIcon",
    value: function getRenderIcon(id, message) {
      return function (_ref) {
        var ref = _ref.ref,
          labelledby = _ref.labelledby,
          events = _ref.events;
        return /*#__PURE__*/React.createElement("span", Object.assign({
          ref: ref,
          "aria-labelledby": labelledby
        }, events), /*#__PURE__*/React.createElement("span", {
          className: styles['aria'],
          id: id
        }, /*#__PURE__*/React.createElement(I18n, {
          i18n: message ? message : '@dm/components.readonly.label'
        })), /*#__PURE__*/React.createElement("span", {
          "aria-hidden": true,
          className: "_dm-icon ".concat(styles['_dm-icon--read-only'], " auto-read-only-indicator")
        }, /*#__PURE__*/React.createElement(I18n, {
          i18n: '@dm/components.readonly.indicator'
        })));
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        message = _this$props.message,
        ariaHidden = _this$props.ariaHidden;
      if (message) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          i18nKey: message
        }, this.getRenderIcon(id, message));
      } else {
        return /*#__PURE__*/React.createElement(AdditionalIntl, {
          messages: this.messages
        }, /*#__PURE__*/React.createElement(Tooltip, {
          i18nKey: "@dm/components.readonly.label"
        }, this.getRenderIcon(id, message, ariaHidden)));
      }
    }
  }]);
  return ReadOnlyIndicator;
}(React.Component);
export { ReadOnlyIndicator as default };